import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EditCheckedToUncheckedDialog({ onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.EditDialog.CheckedToUnchecked',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Stop applying this workflow to sub-accounts' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>{t('subtitle', { defaultValue: 'Saving this change will:' })}</p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              defaultValue:
                'Leave the workflow active on each sub-account where it was previously applied but as a standalone workflow, no longer linked to this parent.',
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue: 'Stop future updates from this workflow cascading to those sub-accounts.',
            })}
          </li>
          <li>{t('bullet3', { defaultValue: 'Prevent new sub-accounts from inheriting this workflow.' })}</li>
        </ul>
        <p className={styles.footer}>
          {t('footer', {
            defaultValue: 'Sub-accounts will be able to edit their copy of the workflow independently from now on.',
          })}
        </p>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Confirm' })}
        </Button>
      </div>
    </Card>
  );
}
